import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { formatDateForInput } from "utils/helpers/dateHelper";

import resource from "pages/EmployeeWorkspace/Resources/trainingAttendedResource";
import AddEditForm from "pages/EmployeeWorkspace/components/Tabs/components/TrainingAttendedTab/components/AddEditForm";
import schema from "pages/EmployeeWorkspace/validation/trainingAttendedSchema";

const defaultValues = {
    organisationName: "",
    startDate: null,
    endDate: null,
    hoursAttended: null
};

const updateGuard = (data) => {
    return {
        startDate: data?.startDate || null,
        endDate: data?.endDate || null,
        hoursAttended: data?.hoursAttended || null
    };
};

const dateFormatter = (item) => {
    return {
        startDate: formatDateForInput(item?.startDate),
        endDate: formatDateForInput(item?.endDate)
    };
};

export default function FormDialog({ open, item, onSave, onCancel }) {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm({
        defaultValues,
        resolver: yupResolver(schema)
    });

    const onError = (errors) => {
        console.log({ errors });
    };

    useEffect(() => {
        if (open) {
            reset({
                ...defaultValues,
                ...item,
                ...dateFormatter(item)
            });
        }
    }, [open, item, reset]);

    const onSubmit = (data) => {
        onSave({
            ...data,
            ...updateGuard(data)
        });
    };

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="md" fullWidth>
            <DialogTitle>
                {item ? `Edit ${resource.title}` : `Add ${resource.title}`}
            </DialogTitle>

            <DialogContent dividers>
                <AddEditForm
                    register={register}
                    errors={errors}
                    control={control}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit(onSubmit, onError)}
                >
                    Apply
                </Button>
            </DialogActions>
        </Dialog>
    );
}
